import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { fontFamily } from '../../../../../../../constants/text';
import { colors } from '../../../../../../../constants/colors';
import NetworkStatusBadge from '../../../../../../SolvPatternLibrary/NetworkStatusBadge';
import ProgressBar from '../../../../../../SolvPatternLibrary/ProgressBars/ProgressBar';
import {
  getDiffBetweenAppliedAndLimitValue,
  formatValueForDisplay,
} from '../../../../../../Account/Profile/Insurance/util/insuranceProgress';

const Until = styled.div.withConfig({ componentId: 'sc-dalzoa-0' })`
  font-family: ${fontFamily.book};
  font-size: 12px;
  color: ${colors.lightText};
  line-height: 20px;
`;

const Subtext = styled(Until).withConfig({ componentId: 'sc-dalzoa-1' })`
  font-family: ${fontFamily.bold};
  margin-bottom: 20px;
`;

const TopStat = styled.div.withConfig({ componentId: 'sc-dalzoa-2' })`
  font-family: ${fontFamily.book};
  color: ${colors.squid};
  font-size: 24px;
  margin: 10px 0 4px 0;
`;

const AppliedLimitContainer = styled.div.withConfig({ componentId: 'sc-dalzoa-3' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

const Applied = styled.div.withConfig({ componentId: 'sc-dalzoa-4' })`
  font-family: ${fontFamily.bold};
  font-size: 12px;
  color: ${colors.purpSizzurp};
  margin-right: 4px;
`;

const Limit = styled.div.withConfig({ componentId: 'sc-dalzoa-5' })`
  font-family: ${fontFamily.book};
  font-size: 12px;
  color: ${colors.lightText};
`;

type Props = {
  tile: object;
  applied: number;
  limit: number;
};

class InProgress extends PureComponent<Props> {
  render = () => {
    const { tile, applied, limit } = this.props;

    return (
      <>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'isInNetwork' does not exist on type 'obj... Remove this comment to see the full error message */}
        <NetworkStatusBadge isInNetwork={tile.isInNetwork} />

        <TopStat>
          {`$${formatValueForDisplay(getDiffBetweenAppliedAndLimitValue(applied, limit))}`}
        </TopStat>

        <Until>until you meet your</Until>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'subtext' does not exist on type 'object'... Remove this comment to see the full error message */}
        <Subtext>{tile.subtext}</Subtext>

        <ProgressBar
          currentValue={applied}
          shouldAnimateOnRender={false}
          shouldAnimateOnSawComponent
          upperBound={limit}
          width="130px"
        />

        <AppliedLimitContainer>
          <Applied>{`$${formatValueForDisplay(applied)}`}</Applied>

          <Limit>
            {' / '}
            {`$${formatValueForDisplay(limit)}`}
          </Limit>
        </AppliedLimitContainer>
      </>
    );
  };
}

export default InProgress;
